import printf from './printf'
import moustache from './moustache'
import xml from './xml'
import combineValidators from '../combineValidators'

const projectValidators = [printf, moustache, xml]
export default combineValidators(projectValidators)
